export const failureHash = {
    AUTOAPPROVE_LIMIT_HIT: "API__EP__BILLING__PLANSUBSCRIPTION__AUTOAPPROVE_LIMIT_HIT",
    LIMIT_HIT_LIVE_STREAMS_CONFIGURED: "API__EP__BILLING__LIMIT_HIT_LIVE_STREAMS_CONFIGURED",
    ORGANIZATION_LIMIT_HIT: "API__EP__BILLING__PLANSUBSCRIPTION__ORGANIZATION_LIMIT_HIT",
    ORGANIZATION_MEMBERSHIP_LIMIT_HIT: "API__EP__BILLING__PLANSUBSCRIPTION__ORGANIZATION_MEMBERSHIP_LIMIT_HIT",
    PAGES_LIMIT_HIT: "API__EP__BILLING__PLANSUBSCRIPTION__PAGES_LIMIT_HIT",
    PLAN_CONVERT_INSUFFICIENT_SOURCE_PERIOD: "API__EP__BILLING__PLAN_CONVERT_INSUFFICIENT_SOURCE_PERIOD",
    PLAN_CONVERT_SOURCE_INVALID: "API__EP__BILLING__PLAN_CONVERT_SOURCE_INVALID",
    PLAN_CONVERT_TARGET_INVALID: "API__EP__BILLING__PLAN_CONVERT_TARGET_INVALID",
    PLAN_SUBSCRIPTION_ACTIVE_REQUIRED: "API__EP__BILLING__PLAN_SUBSCRIPTION_ACTIVE_REQUIRED",
    POST_LIMIT_HIT: "API__EP__BILLING__POST_LIMIT_HIT",
    RECURRING_PAYMENT_PLAN_LOCKED: "API__EP__BILLING__RECURRING_PAYMENT_PLAN_LOCKED",
};
//# sourceMappingURL=plansubscription.static.js.map